export const MessageTabs = {
    Inbox: "Inbox",
    Outbox : "Outbox",
    
}